import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import { Layout } from '../layout';
import type { StarterDashboardCommentsPagePrefetchedDataProps } from '../pageContext';
import { prefetchPageContext, StarterDashboardCommentsPageContextProvider } from '../pageContext';

import { StarterDashboardCommentsErrorHandler } from './ErrorHandler';

export const StarterDashboardComments = withPrefetchedData(
	function StarterDashboardComments({
		prefetchedData,
		setCommentsVisibility,
	}: StarterDashboardCommentsPagePrefetchedDataProps & {
		setCommentsVisibility: (visible: boolean) => void;
	}): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<StarterDashboardCommentsPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={StarterDashboardCommentsErrorHandler}
				loadingFallback={<Loader size="m" my={84} mx="auto" />}
			>
				<Layout setCommentsVisibility={setCommentsVisibility} />
			</StarterDashboardCommentsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
